module.exports = __webpack_public_path__ + "static/media/product_22.b9406739.png";